import ComponentElement from 'components/component-element';
import {formatMoney} from 'methods/utils';

function KurortRoomFilterComponent($element, options = {}) {
    this.initilized = false;

    ComponentElement.call(this, $element, options);

    this.$floorFieldFrom  = this.$element.querySelector('.js-floor-input-from');
    this.$floorFieldTo    = this.$element.querySelector('.js-floor-input-to');
    this.$floorInputFrom  = this.$element.querySelector('[name="min_floor"]');
    this.$floorInputTo    = this.$element.querySelector('[name="max_floor"]');

    this.$floorFieldFrom.addEventListener('change', this.onChangeEvent.bind(this));
    this.$floorFieldTo.addEventListener('change', this.onChangeEvent.bind(this));

    this.initilized = true;
}

KurortRoomFilterComponent.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(KurortRoomFilterComponent.prototype, 'constructor', {
    value: KurortRoomFilterComponent,
    enumerable: false,
    writable: true,
});

KurortRoomFilterComponent.prototype.reset = function () {
    this.setValues(0, 0);
}

KurortRoomFilterComponent.prototype.isInit = function () {
    return !!this.initilized;
}

KurortRoomFilterComponent.prototype.onChangeEvent = function () {
    this.setValues(this.getValueFrom(), this.getValueTo());
    this.emit('change', this.getValueFrom(), this.getValueTo());
}

KurortRoomFilterComponent.prototype.setValues = function (from, to) {
    from = parseInt(from, 10);
    to   = parseInt(to, 10);

    from = isNaN(from) ? 0 : from;
    to   = isNaN(to) ? 0 : to;

    // input
    this.$floorInputFrom.value = from;
    this.$floorInputTo.value   = to;

    // text field
    this.$floorFieldFrom.value = from == 0 ? '' : from;
    this.$floorFieldTo.value   = to == 0 ? '' : to;
}

KurortRoomFilterComponent.prototype.getValues = function () {
    return {
        from: parseInt(this.$floorFieldFrom.value.replace(/\s/g, ''), 10),
        to: parseInt(this.$floorFieldTo.value.replace(/\s/g, ''), 10),
    };
}

KurortRoomFilterComponent.prototype.getValueFrom = function () {
    return this.getValues().from;
}

KurortRoomFilterComponent.prototype.getValueTo = function () {
    return this.getValues().to;
}


export default KurortRoomFilterComponent;
